import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { AudienceSection } from './components/AudienceSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-gray-300 font-sans selection:bg-gold-500/30 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <AudienceSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <Footer data-id="element-6" />
      <RecentPurchaseToast data-id="element-7" />
    </div>;
}